import Container from "../ui/Container";
import StorckSlogan from "../../assets/StorckSlogan.png";
import Facebook from "../../assets/share/Facebook.png";
import FacebookHover from "../../assets/share/FacebookHover.png";
import Pinterest from "../../assets/share/Pinterest.png";
import PinterestHover from "../../assets/share/PinterestHover.png";
import SchonProbiert from "../../assets/footer/SchonProbiert.png";
import Toffifee from "../../assets/footer/Toffifee.png";
import ToffifeeHover from "../../assets/footer/ToffifeeHover.png";
import Nimm2 from "../../assets/footer/Nimm2.png";
import Nimm2Hover from "../../assets/footer/Nimm2Hover.png";
import Knoppers from "../../assets/footer/Knoppers.png";
import KnoppersHover from "../../assets/footer/KnoppersHover.png";
import Werthers from "../../assets/footer/Werthers.png";
import WerthersHover from "../../assets/footer/WerthersHover.png";
import Mamba from "../../assets/footer/Mamba.png";
import MambaHover from "../../assets/footer/MambaHover.png";
import Dickmanns from "../../assets/footer/Dickmanns.png";
import DickmannsHover from "../../assets/footer/DickmannsHover.png";
import Riesen from "../../assets/footer/Riesen.png";
import RiesenHover from "../../assets/footer/RiesenHover.png";
import { NavLink } from "react-router";
import { ReactNode, useState } from "react";
import { cn } from "src/lib/utils";

const Link = ({ children, href, isActive }: { children: ReactNode; href: string, isActive?: boolean }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={href}
      className={cn(
        "text-[#4D4D4D] active:text-cta-active focus:text-cta-click cursor-pointer transition-colors relative",
        isActive && "text-cta-active",
      )}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      {isActive && (
        <div className="absolute -bottom-[4px] left-1/2 transform -translate-x-1/2 w-[20px] h-[2px] bg-muted-foreground" />
      )}
      <div 
        className={cn(
          "absolute -bottom-[4px] left-1/2 transform -translate-x-1/2 w-full h-[2px] bg-muted-foreground origin-center transition-all duration-250 ease-out",
          isHovered ? "scale-x-100" : "scale-x-0"
        )}
      />
    </a>
  );
};

const StyledNavLink = ({ children, to }: { children: ReactNode; to: string }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <NavLink
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      to={to} 
      className="text-[#4D4D4D] active:text-cta-active focus:text-cta-click cursor-pointer transition-colors relative"
    >
      {children}
      {isHovered && (
        <div className="absolute -bottom-[4px] left-1/2 transform -translate-x-1/2 w-[20px] h-[2px] bg-muted-foreground" />
      )}
      <div 
        className={cn(
          "absolute -bottom-[4px] left-1/2 transform -translate-x-1/2 w-full h-[2px] bg-muted-foreground origin-center transition-all duration-250 ease-out",
          isHovered ? "scale-x-100" : "scale-x-0"
        )}
      />
    </NavLink>
  );
};


const Footer = () => {
  return (
    <>
      <div className="bg-input flex flex-col items-center w-full py-[40px]">
        <Container className="flex flex-col 2xl:flex-row items-center min-h-[80px] gap-8 2xl:gap-0">
          <div className="flex-1 lg:mt-[-22px]">
            <a href="https://www.storck.com/de/" target="_blank">
              <img src={StorckSlogan} alt="Storck Logo" className="h-[50px]" />
            </a>
          </div>
          <div className="flex gap-4">
            <a
              className="group w-[26px]"
              href="https://www.facebook.com/merci"
              target="_blank"
            >
              <img
                src={Facebook}
                alt="Facebook Logo"
                className="group-hover:hidden"
              />
              <img
                src={FacebookHover}
                alt="Facebook Logo"
                className="hidden group-hover:inline"
              />
            </a>
            <a
              className="w-[26px] group"
              href="https://www.pinterest.de/sagsmitmerci/"
              target="_blank"
            >
              <img
                src={Pinterest}
                alt="Pinterest Logo"
                className="group-hover:hidden"
              />
              <img
                src={PinterestHover}
                alt="Pinterest Logo"
                className="hidden group-hover:inline"
              />
            </a>
          </div>
          <div className="flex-1 flex flex-col lg:flex-row justify-end gap-[20px] text-muted-foreground text-[14px] font-bold">
            <Link href="https://www.merci.de/de/footer/faq">FAQ</Link>
            <Link href="https://www.merci.de/de/footer/kontakt">Kontakt</Link>
            <StyledNavLink to="/datenschutz">Datenschutz</StyledNavLink>
            <Link href="https://www.merci.de/de/impressum">Impressum</Link>
            <Link href="https://www.merci.de/de/barrierefreiheit">Barrierefreiheit</Link>
            <Link href="https://www.merci.de/de/sitemap">Sitemap</Link>
          </div>
        </Container>
      </div>
      <div className="bg-[#F7F7F7] flex flex-col items-center w-full py-10">
        <Container className="flex flex-col gap-[20px]">
          <div className="flex justify-center h-[29px]">
            <img
              src={SchonProbiert}
              alt="Schon probiert?"
              className="max-h-full"
            />
          </div>
          <div className="flex justify-center h-[60px] gap-[3px] flex-wrap md:flex-nowrap">
            <a
              href="https://www.toffifee.de/"
              target="_blank"
              className="group h-[60px] md:h-auto flex justify-end"
            >
              <img
                src={Toffifee}
                alt="Toffifee Logo"
                className="max-h-full group-hover:hidden"
              />
              <img
                src={ToffifeeHover}
                alt="Toffifee Logo"
                className="max-h-full hidden group-hover:inline"
              />
            </a>
            <a
              href="https://www.nimm2.de/"
              target="_blank"
              className="group h-[60px] md:h-auto flex justify-start"
            >
              <img
                src={Nimm2}
                alt="Nimm2 Logo"
                className="max-h-full group-hover:hidden"
              />
              <img
                src={Nimm2Hover}
                alt="Nimm2 Logo"
                className="max-h-full hidden group-hover:inline"
              />
            </a>
            <a
              href="https://www.knoppers.de/"
              target="_blank"
              className="group h-[60px] md:h-auto flex justify-end"
            >
              <img
                src={Knoppers}
                alt="Knoppers Logo"
                className="max-h-full group-hover:hidden"
              />
              <img
                src={KnoppersHover}
                alt="Knoppers Logo"
                className="max-h-full hidden group-hover:inline"
              />
            </a>
            <a
              href="https://www.werthers-original.de/"
              target="_blank"
              className="group h-[60px] md:h-auto flex justify-start"
            >
              <img
                src={Werthers}
                alt="Werthers Logo"
                className="max-h-full group-hover:hidden"
              />
              <img
                src={WerthersHover}
                alt="Werthers Logo"
                className="max-h-full hidden group-hover:inline"
              />
            </a>
            <a
              href="https://www.mamba.de/"
              target="_blank"
              className="group h-[60px] md:h-auto flex justify-end"
            >
              <img
                src={Mamba}
                alt="Mamba Logo"
                className="max-h-full group-hover:hidden"
              />
              <img
                src={MambaHover}
                alt="Mamba Logo"
                className="max-h-full hidden group-hover:inline"
              />
            </a>
            <a
              href="https://www.dickmanns.de/"
              target="_blank"
              className="group h-[60px] md:h-auto flex justify-start"
            >
              <img
                src={Dickmanns}
                alt="Dickmanns Logo"
                className="max-h-full group-hover:hidden"
              />
              <img
                src={DickmannsHover}
                alt="Dickmanns Logo"
                className="max-h-full hidden group-hover:inline"
              />
            </a>
            <a
              href="https://www.riesen.de/"
              target="_blank"
              className="group h-[60px] md:h-auto flex justify-center"
            >
              <img
                src={Riesen}
                alt="Riesen Logo"
                className="max-h-full group-hover:hidden"
              />
              <img
                src={RiesenHover}
                alt="Riesen Logo"
                className="max-h-full hidden group-hover:inline"
              />
            </a>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Footer;
